__turbopack_context__.v({
  "backgroundLayer": "UwFOIa_backgroundLayer",
  "content": "UwFOIa_content",
  "geistMonoNumbers": "UwFOIa_geistMonoNumbers",
  "lbCardBg": "UwFOIa_lbCardBg",
  "lbCardBlur": "UwFOIa_lbCardBlur",
  "lbMetaLabel": "UwFOIa_lbMetaLabel" + " " + "UwFOIa_monoUppercase",
  "lbRadialStroke": "UwFOIa_lbRadialStroke",
  "lbStrokeCard": "UwFOIa_lbStrokeCard",
  "lbStrokeFrosted": "UwFOIa_lbStrokeFrosted",
  "lbToggleBlur": "UwFOIa_lbToggleBlur",
  "monoUppercase": "UwFOIa_monoUppercase",
  "pageRoot": "UwFOIa_pageRoot",
  "pl-accordion-control": "UwFOIa_pl-accordion-control",
  "sectionWidth": "UwFOIa_sectionWidth",
});
